import React from 'react';

import { OptionButton, Label, UsdValue, CachedLabel } from './styled';

export interface StakeOptionProps {
  label: string;
  selected: boolean;
  onClick: () => void;
  usdValue?: number | null;
  showUsd?: boolean;
  isCached?: boolean;
  /**
   * Optional explicit subtitle. When provided, replaces the auto-generated
   * USD line (used for the Free option to show "No entry").
   */
  subtitle?: string;
}

const StakeOption: React.FC<StakeOptionProps> = ({
  label,
  selected,
  onClick,
  usdValue,
  showUsd = true,
  isCached = false,
  subtitle,
}) => {
  const hasUsd = showUsd && typeof usdValue === 'number' && usdValue > 0;

  return (
    <OptionButton type="button" selected={selected} onClick={onClick}>
      <Label>{label}</Label>
      {subtitle ? (
        <UsdValue selected={selected}>{subtitle}</UsdValue>
      ) : hasUsd ? (
        <UsdValue selected={selected}>
          {`≈ ${parseFloat(usdValue.toFixed(4))} USD`}
          {isCached && <CachedLabel aria-label="cached price">(cached)</CachedLabel>}
        </UsdValue>
      ) : null}
    </OptionButton>
  );
};

export default StakeOption;
